<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <div class="d-flex">
      <h1 class="mb-3">Resursi</h1>
    </div>
    <b-card-group columns class="mb-3" v-if="hasCollections">
      <Collection v-for="collection in collections" :key="collection.id" :collection="collection" />
    </b-card-group>
    <div v-else>
      <b-alert variant="warning" show>
         Trenutno nema resursa.
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import Collection from "@/components/Collection";
export default {
  components: {
    Collection
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      collections: "resources/collections",
      project_title: "project/title"
    }),
    hasCollections(){
      return this.collections.length > 0
    }
  },
  created() {
    this.$store
      .dispatch("resources/fetchCollections")
      .then()
      .catch();
    const crumbs = [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "Resursi",
        to: { name: "resources" },
        active: true
      }
    ];
    this.$store.commit("setBreadcrumbs", crumbs);
  }
};
</script>

<style>
</style>